import { createClient } from '@supabase/supabase-js';

// URL da API do seu projeto Supabase
const supabaseUrl = 'https://ohtchoybvpssetuprsrw.supabase.co';

// Chave ANON PUBLIC (Segura para uso no Front-end)
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9odGNob3lidnBzc2V0dXByc3J3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODU4NTkxODcsImV4cCI6MjEwMTQzNTE4N30.Sw4vGA7p2n8QmlkSye79S_ZWtuiT8cPTv2XuvtT10BU';

// Cria e exporta o cliente do Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);